export default {
  Excellent: '优秀',
  Good: '良好',
  Error: '异常',
  ExcellentTip: '当前时间区间内未发生关键异常事件',
  GoodTip: '当前时间区间内发生关键异常事件且已恢复（对于状态类告警为已告警）',
  ErrorTip: '当前时间区间内发生关键异常事件且未处理',
  BranchExcellentTip: '当前时间区间内未发生网关异常事件',
  BranchGoodTip: '当前时间区间内发生网关异常且已恢复',
  BranchErrorTip: '当前时间区间内发生异常事件且未恢复',
  Type: '监控类型',
  HealthStatus: '健康状态',
  Branch: '分支机构',
  Flow: '流量',
  Overview: '概览',
  BranchNums: '分支机构数',
  ConvergentBranchNum: '收口分支数',
  ServiceGateway: '服务中网关',
  ServiceErrorGateway: '服务异常网关',
  ServiceHealthStatus: '近24小时服务健康状态',
  AlarmEvent: '告警事件',
  BusinessIndicators: '近24小时业务关键指标',
  NetworkMonitor: '网络质量监控',
  UpBandwidthPeak: '上行带宽峰值',
  DownBandwidthPeak: '下行带宽峰值',
  Delay: '时延',
  Jitter: '抖动',
  PacketLoss: '丢包',
  BranchHealthStatus: '近24小时分支健康状态',
  BranchFlowTop5: '近24小时分支流量（top5）',
  BusinessDataAnalysis: '业务数据分析',
  CompareUP: '与24小时前数据对比，数据增长',
  CompareDown: '与24小时前数据对比，数据减少',
  CompareUnchange: '与24小时前数据对比，维持不变',
  ServiceHealthTips1: '服务健康将选取关键的中高级别的告警事件发生情况进行评估。若您未设置',
  LastHealthTips: '，请先配置。配置后将开启监控并进行健康评估。您可以点击上方评估设置，自定义评估维度。', // ServiceHealthTips1 + 告警配置 + ServiceHealthTips2 为一句
  BranchHealthTips1: '分支健康状态为分支服务状态的监控评估，根据当前时间区间内发生网关异常的情况进行健康评估。您可以在',
  BranchHealthTips2: '查看网关异常日志。',
  BandwidthRateCompareUP: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）增长',
  BandwidthRateCompareDown: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）减少',
  BandwidthRateCompareUnchange: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）维持不变',
  BandwidthUsage: '最大带宽使用率',
  AlertSettingTips: '您可以点自定义选择事件。 系统将根据所选监控事件发生关键异常事件的情况进行健康评估。必须开启监控告警开关的事件才能进行加入健康评估。',
  AlarmCheckBoxTips: '请设置告警配置并开启告警开关',
  NoMonitorAlarm: '未设置监控告警',
}